import React, { useEffect, useRef } from 'react';
import { MonthsProps as DayPickerMonthsProps, useDayPicker } from 'react-day-picker';

export interface MonthsProps extends DayPickerMonthsProps {
  onTableMouseLeave?: () => void;
}

export const Months: React.FC<MonthsProps> = ({ onTableMouseLeave, children }) => {
  const { classNames, styles } = useDayPicker();
  const divRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    const divEl = divRef.current;
    if (divEl == null) return;
    const tableEl = divEl.querySelector('.rdp-tbody');
    if (tableEl == null) return;
    const handler = () => onTableMouseLeave?.();
    tableEl.addEventListener('mouseleave', handler);
    return () => {
      tableEl.removeEventListener('mouseleave', handler);
    };
  }, [onTableMouseLeave]);
  return (
    <div className={classNames.months} style={styles.months} ref={divRef}>
      {children}
    </div>
  );
};
